
<template>
    <div style="padding: 2rem 3rem; text-align: left;">
        <div class="field">
            <b-form>
                <b-form-group label="Account Name:" label-for="register-account-name">
                    <b-form-input
                        id="register-account-name"
                        v-model="model.account.account_name"
                        type="text"
                        required
                    />
                </b-form-group>

                <b-form-group label="First Name:" label-for="register-account-user-firstname">
                    <b-form-input
                        id="register-account-user-firstname"
                        v-model="model.account.first_name"
                        type="text"
                        required
                    />
                </b-form-group>

                <b-form-group label="Last Name:" label-for="register-account-user-lastname">
                    <b-form-input
                        id="register-account-user-lastname"
                        v-model="model.account.last_name"
                        type="text"
                        required
                    />
                </b-form-group>

                <b-form-group label="Your Email:" label-for="register-account-email">
                    <b-form-input
                        id="register-account-email"
                        v-model="model.account.email"
                        type="email"
                        required
                    />
                </b-form-group>

                <b-form-group label="Password:" label-for="register-account-password">
                    <b-form-input
                        id="register-account-password"
                        type="password"
                        placeholder="Please enter a new password"
                        v-model="model.account.password"
                        required
                    />
                </b-form-group>
            </b-form>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            model: { type: Object }
        },

        mounted(){ this.$emit('can-continue', {value: true}) }
    }
</script>
